module.exports = __webpack_public_path__ + "static/media/dental_wipe.89c69281.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Products/sds/ca/en/dental_wipe.pdf
// module id = 321
// module chunks = 0